module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/equipment05-025e1e92ef55fc49c71e4a1980ec7ba3.png";